import '../../styles/sections/section-list-group-content.scss'

function updateListActiveTab(event) {
    const listId = event.target.getAttribute(`data-list`)
    const targetId = event.target.getAttribute(`data-target`)
    const lists = document.querySelectorAll(`.list-group[id="${listId}"]`)

    lists.forEach((list => {
        list.querySelector(`.list-group-item.active`).classList.remove(`active`)
        list.querySelector(`.list-group-item[data-target="${targetId}"]`).classList.add(`active`)

        if (!Shopify.designMode) {
            list.querySelector(`.tab-pane.active`).classList.remove(`active`)
            list.querySelector(`.tab-pane[id="${targetId}"]`).classList.add(`active`)
        }
    }))
}

const listGroups = document.querySelectorAll(`.list-group`)
listGroups.forEach((group) =>  {
    const labels = group.querySelectorAll(`.list-group-item`)
    labels.forEach((label) =>  {
        label.addEventListener(`click`, updateListActiveTab)
    })
})